var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoVodafone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 173.459 100.108"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Logo-Vodafone_svg__logo-vodafone-cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
  d: "M5.6 0h162.2a5.6 5.6 0 0 1 5.7 5.6v88.9a5.6 5.6 0 0 1-5.7 5.6H5.6A5.6 5.6 0 0 1 0 94.5V5.6A5.6 5.6 0 0 1 5.6 0",
  style: {
    fill: "#ed1c24"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__polyline4291",
  d: "m28.8 61.8-3.8 11-3.7-11h-4.9l6 16.2h5.2l6-16.2z",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4293",
  d: "M66.5 55.2v8a7.7 7.7 0 0 0-4.7-1.7 8.3 8.3 0 0 0-8.2 8.3 8.2 8.2 0 0 0 8.2 8.3 8.7 8.7 0 0 0 4.7-1.5V78h4V55.2zM58 69.8a4.3 4.3 0 0 1 4.2-4.4 4.4 4.4 0 0 1 0 8.8 4.3 4.3 0 0 1-4.2-4.4",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4295",
  d: "M86.3 61.8v1.4H86a7.1 7.1 0 0 0-4.7-1.7 8.2 8.2 0 0 0-8 8.3 8.1 8.1 0 0 0 8 8.3 8.8 8.8 0 0 0 4.9-1.5V78h4V61.8h-4m-8.6 8a4.4 4.4 0 1 1 4.3 4.4 4.4 4.4 0 0 1-4.3-4.4",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4297",
  d: "M101.7 61.8h-2.6v-1c0-1 0-2.3 1.7-2.3h.7v-3.6h-1C96.7 55 95 56.2 95 60v1.7h-2v3.8h2V78h4.1V65.6h2.6z",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4299",
  d: "M126.8 63.2a7.1 7.1 0 0 1 4.7-1.7c3.8 0 6 2.4 6 5.6V78h-4.2v-9.5a2.8 2.8 0 0 0-3-3 3.1 3.1 0 0 0-3.4 3.4v9h-4.3V62h4.2v1.3",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4301",
  d: "M152.5 68a3.6 3.6 0 0 0-3.8-2.9 3.5 3.5 0 0 0-3.8 3h7.6m-7.7 3a3.8 3.8 0 0 0 4 3.6 3.3 3.3 0 0 0 3.2-1.9h4.6a8 8 0 0 1-7.7 5.3 8.2 8.2 0 0 1-8.5-8.3 8.4 8.4 0 0 1 8.5-8.3 8.3 8.3 0 0 1 8.1 8.3 4.7 4.7 0 0 1-.1 1.4h-12.1z",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4303",
  d: "M45.8 62a3.5 3.5 0 0 0-2.6 3.3v.1c2.4.6 3.6 2.2 3.6 4.4a4.4 4.4 0 0 1-4.4 4.4 4.9 4.9 0 0 1-4.7-5c0-3.8 3-7 7.6-7.2h.3a7 7 0 0 0-3.2-.6 8.4 8.4 0 1 0 8.8 8.4 8.7 8.7 0 0 0-5.4-7.8",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4305",
  d: "M111.2 61.5a8.3 8.3 0 0 0-3.3 16 3.4 3.4 0 0 0 2.7-3.3 4.3 4.3 0 0 1-3.6-4.4 4.4 4.4 0 0 1 4.4-4.4 4.8 4.8 0 0 1 4.7 5 7.5 7.5 0 0 1-7.6 7.3h-.4a11.8 11.8 0 0 0 3.1.6 8.6 8.6 0 0 0 8.8-8.5 8.5 8.5 0 0 0-8.8-8.3",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  id: "Logo-Vodafone_svg__path4307",
  d: "M92.8 22.8a5.3 5.3 0 0 0-4 5v.3c3.6.7 5.5 3.2 5.5 6.5a6.7 6.7 0 0 1-6.7 6.7 7.4 7.4 0 0 1-7.1-7.7c0-5.5 4.7-10.8 11.5-11a2 2 0 0 1 .5.1 13.2 13.2 0 0 0-18 12 13.2 13.2 0 1 0 18.3-12",
  className: "Logo-Vodafone_svg__logo-vodafone-cls-2"
})));
export default SvgLogoVodafone;